import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BackgroundBlobs from '../components/BackgroundBlobs';

const AppLoginComplete = () => {
  const { completeGoogleLoginToken } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const token = useMemo(() => searchParams.get('token') || searchParams.get('google_login_token'), [searchParams]);

  useEffect(() => {
    let cancelled = false;

    const finishLogin = async () => {
      if (!token) {
        setError('Login token is missing. Please try Google login again.');
        return;
      }

      console.info('[HardayLogin] App login completion URL reached', {
        href: window.location.href,
        hasToken: Boolean(token),
      });
      const result = await completeGoogleLoginToken(token);
      if (cancelled) return;

      if (result.success) {
        const nextPath = result.data?.nextPath || sessionStorage.getItem('hardayPostLoginPath') || '/dashboard';
        sessionStorage.removeItem('hardayPostLoginPath');
        navigate(nextPath, { replace: true });
      } else {
        setError(result.error || 'This login link is invalid or expired. Please try again.');
      }
    };

    finishLogin();

    return () => {
      cancelled = true;
    };
  }, [completeGoogleLoginToken, navigate, token]);

  return (
    <div className="w-full max-w-md mx-auto min-h-screen relative overflow-hidden bg-white">
      <BackgroundBlobs />
      <div className="relative z-10 flex min-h-screen items-center justify-center p-6 text-center">
        <div className="glass-panel rounded-[24px] p-6 space-y-4">
          <h1 className="text-2xl font-bold text-[#000000] font-['Outfit']">
            {error ? 'Login link expired' : 'Signing you in...'}
          </h1>
          <p className="text-sm text-[#666666] font-['DM_Sans']">
            {error || 'Please wait while Harday completes Google login inside the app.'}
          </p>
          {error && (
            <button
              type="button"
              onClick={() => navigate('/login?source=android_apk', { replace: true })}
              className="w-full bg-gradient-to-r from-[#9333EA] via-[#EC4899] to-[#7C3AED] text-white py-3.5 rounded-full font-semibold"
            >
              Try login again
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppLoginComplete;
